import { t } from '@hefe/i18n';
import { AssignableType } from '@hefe/models';
import { TasksSlice } from '@hefe/store';
import { Radio, Row, Space, Typography } from 'antd';
import { FaUser, FaUsers } from 'react-icons/fa';
import { useAppDispatch } from '../../../../../store/store';

export default function TasksAutoAssignmentWizardModeComponent() {
  const dispatch = useAppDispatch();

  const selectMode = (mode: string) => {
    let type = AssignableType.USER;
    switch (mode) {
      case '1':
        type = AssignableType.USER;
        break;
      case '2':
        type = AssignableType.BASKETBALL_TEAM;
        break;
      default:
        break;
    }

    dispatch(TasksSlice.actions.setWizardMode(type));
  };

  return (
    <Row align="middle" justify="center">
      <Radio.Group
        defaultValue="1"
        size="large"
        onChange={(event) => selectMode(event.target.value)}
      >
        <Radio.Button value="1">
          <Space direction="horizontal">
            <FaUser />
            <Typography.Text>
              {t('tasks.auto_assignment.steps.mode.users')}
            </Typography.Text>
          </Space>
        </Radio.Button>
        <Radio.Button value="2">
          <Space direction="horizontal">
            <FaUsers />
            <Typography.Text>
              {t('tasks.auto_assignment.steps.mode.basketball_teams')}
            </Typography.Text>
          </Space>
        </Radio.Button>
      </Radio.Group>
    </Row>
  );
}
